<template>	   
	<v-container>
		<v-layout row wrap>
      <v-flex xs6 pa-1> 
        <label for="">Variables</label>
        <v-autocomplete solo
          :items="variables"
          item-value="id"
          item-text="name"
          v-model="filters.id_variable"
          label="Variables"
        >
          <template v-slot:item="data">
            <v-list-item-action @click="data.item.active = !data.item.active">
              <v-icon>fas fa-subscript</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
              <v-list-item-sub-title>Tipo: {{ data.item.category }} | Nivel: {{ data.item.level }}  </v-list-item-sub-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs6 pa-1>
        <label for="">Localidades</label>
        <v-autocomplete solo
            :items="localities"
            item-text="label" 
            item-value="value" 
            v-model="filters.id_point"
            label="Localidades"
          >
			     <template v-slot:item="data">			     		
		    		<v-list-item-action>
		          <v-icon>fas fa-globe-americas</v-icon>
		        </v-list-item-action>
			    	<v-list-item-content>
			        <v-list-item-title v-html="data.item.label"></v-list-item-title>
			        <v-list-item-sub-title><strong>Provincia:</strong> {{ data.item.province }}</v-list-item-sub-title>
			      </v-list-item-content>
			    </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs6 pa-1> 
        <label for="">Fecha inicial</label>
        <v-text-field
          name="name" v-model="filters.dateInit"
          label="Fecha" solo
          id="id" type="date"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 pa-1> 
        <label for="">Fecha final</label>
        <v-text-field
          name="name" v-model="filters.dateEnd"
          label="Fecha" solo
          id="id" type="date"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-btn color="success"  @click="getData()"><v-icon>fas fa-search</v-icon></v-btn>
        <v-btn color="indigo" @click="addDataSet()">Agregar Dato</v-btn>
        <v-btn color="error" @click="resetChart()"><v-icon>fas fa-trash</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-card :min-height="500">
      <v-card-title primary-title>
        {{ graphic.title }}
      </v-card-title>
      <v-card-text>
				<line-chart :chart-data="lineChartData" :options="chartOptions" :key="chartKey"></line-chart>
      </v-card-text>
      <v-card-actions>
        
      </v-card-actions>
    </v-card>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getVariables();
			this.getLocalities();
		},
		props: [

		],
		data(){
			return {
				baseRoute: process.env.VUE_APP_URL + 'api/gis',
				lineChartData: {
      		labels: [],
      		datasets: []
      	},
      	chartOptions: {
		      responsive: true,
		      maintainAspectRatio: false
		    },
      	filters: {
      		dateInit: '',
      		dateEnd: '',
      		id_variable: [],
      		id_point: [],
      		type: false,
      	},
      	variables: [],
      	localities: [],
      	graphic: {
      		title: 'Grafico:'
      	},
      	chartData: {},
      	chartKey: 0,
			}
		},
		methods: {
			getData(){

				axios.put(this.baseRoute + '/results/getGraphicsData', this.filters).then((res) => {
					this.chartData = {
						labels: res.data.labels,
						datasets: [
							{
								label: res.data.label,
								backgroundColor: 'transparent',
								borderColor:'#' + Math.floor(Math.random()*16777215).toString(16),
								data: res.data.dataset
							}
						]
					}
					this.setChart();
				}).catch((error) =>  {

				});
			},
			addDataSet(){
				axios.put(this.baseRoute + '/results/getGraphicsData', this.filters).then((res) => {
					this.chartData.datasets.push({
						label: res.data.label,
						backgroundColor: 'transparent',		
						//backgroundColor:'#' + Math.floor(Math.random()*16777215).toString(16),
						borderColor:'#' + Math.floor(Math.random()*16777215).toString(16),		
						data: res.data.dataset
					})
					this.setChart()
				}).catch((error) =>  {

				});
			},
			resetChart(){
				this.chartData = {
					labels:[],
					datasets: [
						{	
							label: '',
							backgroundColor:'#' + Math.floor(Math.random()*16777215).toString(16),
							data: []
						},
					]
				}
				this.setChart()
			},
			setChart(){
				this.lineChartData = {
						labels: this.chartData.labels,
						datasets: this.chartData.datasets
					}
			},
			getVariables(){
        axios.get(this.baseRoute + '/variables/getSelect').then((res) => {
          this.variables = res.data;
        }).catch((error) => {
          this.alert = {
            messague: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
            color: 'error',
            active: true,
            icon: 'fas fa-bell',            
          }
        });
      },
      getLocalities(){
				//window.clearInterval(this.interval);
				axios.get(this.baseRoute + '/district/getSelect/habilited').then((res) => {
					this.localities = res.data;
				}).catch((error) => {

				});
			},
		},
		watch: {

		},
		computed: {

		},
	}
</script>